import React from 'react';

import { useQuery } from '@app/QueryClient';
import {
	apiNewsFeed,
	apiNewVsReturning,
	apiPaymentCardsAnalytics,
	apiTransactionsValue,
} from '@app/Services/Dashboard';
import { useQueryString } from '@app/useQueryString';

import { generatedKeys } from '../queryKeysFactory';
import { useInfiniteQuery } from '@tanstack/react-query';

const { dashboard } = generatedKeys;

export function useTransactionsValue() {
	const [{ branch, dateFrom, dateTo, rangeType }] = useQueryString();

	const q = useQuery({
		queryFn: apiTransactionsValue,
		queryKey: dashboard.transactionsValues({
			dateFrom,
			dateTo,
			rangeType,
			branch,
		}),
		staleTime: Infinity,
		enabled: !!dateFrom && !!dateTo && !!rangeType,
	});

	React.useDebugValue(q);

	return q;
}

export function useNewVsReturning() {
	const [{ branch, dateFrom, dateTo, rangeType }] = useQueryString();

	const q = useQuery({
		queryFn: apiNewVsReturning,
		queryKey: dashboard.analyticsNewVsReturning({
			dateFrom,
			dateTo,
			rangeType,
			branch,
		}),
		staleTime: Infinity,
		enabled: !!dateFrom && !!dateTo && !!rangeType,
	});

	React.useDebugValue(q);

	return q;
}

export function usePaymentCardsAnalytics() {
	const [{ branch, dateFrom, dateTo, rangeType }] = useQueryString();

	const q = useQuery({
		queryFn: apiPaymentCardsAnalytics,
		queryKey: dashboard.analyticsPaymentCards({
			dateFrom,
			dateTo,
			rangeType,
			branch,
		}),
		staleTime: Infinity,
		enabled: !!dateFrom && !!dateTo && !!rangeType,
	});

	React.useDebugValue(q);

	return q;
}

export function useAnalyticsNewsFeed() {
	const [{ branch, dateFrom, dateTo }] = useQueryString();

	const q = useInfiniteQuery({
		queryFn: ({ pageParam, queryKey }: any) =>
			apiNewsFeed({ pageParam, queryKey }),
		queryKey: dashboard.newsFeed({
			branch,
			dateFrom,
			dateTo,
		}),
		getNextPageParam: (lastPageData: any) => {
			if (lastPageData?.currentPage < lastPageData?.lastPage) {
				return lastPageData?.currentPage + 1;
			}

			return undefined;
		},
		staleTime: Infinity,
		enabled: !!dateFrom && !!dateTo,
	});

	React.useDebugValue(q);
	return q;
}
